module.exports = __webpack_public_path__ + "media/images/common/my_nav_2-bc1c30f2fab8af904dedf1ad11add826.png";